import React from 'react';
import {modalImg} from './../utils/img';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

export default class ModalSlider extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        if(this.props.status) {
        }
    }

    render() {
        return(
            <Splide 
                aria-label="My Favorite Images"
                options={
                    {
                        arrows: false,
                    }
                }
            >
                {
                    this.props.slides.map((slide, i) => {
                        return (
                            <SplideSlide key = {i}>
                                <img src={slide} alt="Show"/>
                            </SplideSlide>
                    )})
                }
                
            </Splide>
        )
    }
}